import { createContext, useCallback, useMemo, useState } from "react";
import type { ReactNode } from "react";

export interface MenuItem {
  label: string;
  onSelect: () => void;
  danger?: boolean;
  divider?: never;
}
export interface Divider { divider: true }
export type MenuEntry = MenuItem | Divider;

interface OpenArgs { x: number; y: number; items: MenuEntry[] }
interface Ctx {
  open: OpenArgs | null;
  show: (a: OpenArgs) => void;
  close: () => void;
}

export const ContextMenuContext = createContext<Ctx | null>(null);

export function ContextMenuProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState<OpenArgs | null>(null);
  const show = useCallback((a: OpenArgs) => setOpen(a), []);
  const close = useCallback(() => setOpen(null), []);
  const value = useMemo(() => ({ open, show, close }), [open, show, close]);
  return <ContextMenuContext.Provider value={value}>{children}</ContextMenuContext.Provider>;
}
